
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 13 13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.4 0a6.4 6.4 0 100 12.8A6.4 6.4 0 006.4 0zm1.332 9.919c-.33.13-.592.228-.788.297a2.079 2.079 0 01-.684.102c-.399 0-.71-.098-.93-.292a.942.942 0 01-.331-.74c0-.117.008-.236.024-.358.017-.121.043-.258.08-.41l.412-1.457c.036-.14.068-.273.093-.396.025-.125.036-.24.036-.343 0-.186-.038-.316-.114-.389-.078-.073-.224-.109-.44-.109-.107 0-.217.016-.329.05a4.654 4.654 0 00-.286.094l.109-.448c.27-.11.528-.204.774-.282.247-.08.48-.119.7-.119.395 0 .7.097.916.288.214.19.322.44.322.745 0 .064-.008.175-.022.334-.015.16-.043.306-.083.44l-.41 1.452c-.033.116-.063.25-.09.399-.027.149-.04.262-.04.339 0 .193.043.324.13.394.085.07.235.105.448.105.1 0 .212-.018.339-.052.126-.035.217-.066.274-.092l-.11.448zm-.073-5.894a.979.979 0 01-.69.267.99.99 0 01-.694-.267.85.85 0 01-.289-.646.86.86 0 01.29-.648.982.982 0 01.693-.27c.269 0 .5.09.69.27.192.179.288.396.288.648a.85.85 0 01-.288.646z","fill":"#6F6F6F"}})])
          )
        }
      }
    